export const TimeAgo = (timestamp: string) => {
  const getTimeAgo = (timestamp: string) => {
    const now = new Date();
    const pastDate = new Date(timestamp);
    const seconds = Math.floor(((now as any) - (pastDate as any)) / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(seconds / 3600);
    const days = Math.floor(seconds / 86400);
    const month = Math.floor(seconds / 2592000);
    // `${days} روز${days !== 1 ? "s" : ""} قبل`;
    if (seconds < 60) {
      return `${seconds} ثانیه${seconds !== 1 ? "" : ""} قبل`;
    } else if (minutes < 60) {
      return `${minutes} دقیقه${minutes !== 1 ? "" : ""} قبل`;
    } else if (hours < 24) {
      return `${hours} ساعت${hours !== 1 ? "" : ""} قبل`;
    } else if (days < 29) {
      return `${days} روز${days !== 1 ? "" : ""} قبل`;
    } else {
      return `${month} ماه${month !== 1 ? "" : ""} قبل`;
    }
  };

  return getTimeAgo(timestamp);
};
